import { FaBoxes, FaMotorcycle } from 'react-icons/fa'
import { GiMoneyStack } from 'react-icons/gi'
import { useCouponRules } from '../couponRulesContext';

import { Container } from './style';

export function CardRule({ title, explain, type }) {
    const { cardCouponRuleSelected, setCardCouponRuleSelected } = useCouponRules()

    return(
        <Container 
            cardCouponRuleSelected={cardCouponRuleSelected}
            type={type}
            onClick={() => setCardCouponRuleSelected(type)}
        >
                {
                    type === 0 ?
                        <FaBoxes /> 
                    :
                    type === 1 ?
                        <FaMotorcycle />
                    :
                    type === 2 ?
                        <GiMoneyStack />
                    : <></>
                }

                <div>
                    <strong>{title}</strong>
                    <p>{explain}</p>
                </div>
        </Container>
    )
}
